import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import jwt_decode from 'jwt-decode';

import { AuthenticationService } from '@app/_services';
import { tap } from 'rxjs/operators';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    let currentUser = this.authenticationService.currentUserValue;

    if (currentUser && currentUser.token) {
      request = request.clone({
        setHeaders: {
          key: 'rejc41r2421sk8423jd39',
          Authorization: `${currentUser.token}`,
        },
      });
    } else {
      request = request.clone({
        setHeaders: {
          key: 'rejc41r2421sk8423jd39',
        },
      });
    }

    
    return next.handle(request);
    // return next.handle(request).pipe(
    //   tap(null, error => {
    //     if (error.status === 401) {
    //       this.authenticationService.logout();
    //       window.location.reload();
    //     }
    //   })
    // );

    // return next.handle(request)
    //   .pipe(tap(() => {},
    //     (err: any) => {

    //       console.log(err);
    //       if (err.status === 200) {
    //         return;
    //       }
    //       else if(err.status === 401)
    //       {
    //           window.location.reload();
    //       }
    //       else
    //       {
    //         console.log(err);
    //         // localStorage.removeItem('currentUserData');
    //         // window.location.href = '/login';
    //       }
    //     }
    //   ));
  }
}
